import type { VoucherStore } from '@/scopes/payment/domain/vouchers/types'
import { useStore } from 'zustand'
import { voucherStore } from './store'

export function useVoucherStore<T>(selector: (state: VoucherStore) => T): T {
  return useStore(voucherStore, selector)
}
